const isDebug = process.env.REACT_APP_DEBUG === 'true';
import toast from 'react-hot-toast';

export function showLog(...args) {
    if(isDebug){
        const milliseconds = new Date().getTime();
        console.log(`${milliseconds}:`, ...args);
    }
}

export function showWarn(...args) {
    if (isDebug) {
        const milliseconds = new Date().getTime();
        console.warn(`[WARN] ${milliseconds}:`, ...args);
    }
}

export function showError(error) {
    if (isDebug) {
        const milliseconds = new Date().getTime();
        let msg = 'Error message is empty';
        let stack = 'No stack trace available';
        if(error){
            msg = error.message || 'Msg empty';
            stack = error.stack || 'Stack empty';
        }
        console.error(`${milliseconds}:`, msg);
        console.error(`${milliseconds}:`, stack);
    }
}

export const logToast = (label, value, type = 'log', duration = 5000) => {
  if (!isDebug) return;

  const message = typeof value === 'object' ? JSON.stringify(value) : String(value);
  const text = `${label}: ${message}`;

  if (type === 'error') {
    toast.error(text, { duration });
  } else if (type === 'warn') {
    toast(text, { icon: '⚠️', duration });
  } else {
    toast.success(text, { duration });
  }
};

